import React from 'react';
import { useTranslation } from 'react-i18next';

import Seo from '../../components/seo';
import useRedirect from '../../hooks/redirect';
import { TPageProps } from '../../page-props';

function Trips(props: TPageProps) {
  const {
    pageContext: { slug },
    location: { search },
  } = props;
  const { t } = useTranslation();

  useRedirect({ slug, search });

  return (
    <Seo
      isRoot
      description={t('geovelo.pages_descriptions.trips') || null}
      title={`${t('geovelo.pages_titles.trips')}`}
      {...props}
    />
  );
}

export default Trips;
